// grade can be 0 or '0'
const hasGrade = ({ displayGrade } = {}) =>
  displayGrade !== undefined && displayGrade !== null;

export default hasGrade;
